export interface CustomerData {
  customerId: number | undefined;
  memberId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
}

export enum Device {
  iOS = 'ios',
  Android = 'android',
}
